import { Injectable } from '@angular/core';

import { merge, Observable, tap } from 'rxjs';

import { WebSocketEventsEnum } from '@shared/websocket';
import { AccountUser } from '@shared/user/models';
import {
  AccountApiService,
  AccountUsersQuery,
  AccountUsersStore,
  SocketService,
} from '@tablesready/frontend-store';
import { UserApiService } from '@tablesready/frontend-auth';

@Injectable({ providedIn: 'root' })
export class AccountUsersService {
  constructor(
    private readonly query: AccountUsersQuery,
    private readonly store: AccountUsersStore,
    private readonly userApiService: UserApiService,
    private readonly accountApiService: AccountApiService,
    private readonly socketService: SocketService,
  ) {}

  load(): Observable<AccountUser[]> {
    return this.accountApiService.getAccountUsers()
      .pipe(tap(accountUsers => this.store.set(accountUsers)));
  }

  selectAll(): Observable<AccountUser[]> {
    return this.query.selectAll();
  }

  getByUserId(userId: string): AccountUser {
    return this.query.getAll().find(accountUser => accountUser.userId === userId);
  }

  listenToChanges() {
    return merge(
      this.socketService.getEventStream<AccountUser[]>(WebSocketEventsEnum.accountUserCreated)
        .pipe(tap(accountUser => this.store.add(accountUser))),
      this.socketService.getEventStream<AccountUser[]>(WebSocketEventsEnum.accountUserUpdated)
        .pipe(
          tap(accountUsers => {
            for (let i = 0; i < accountUsers.length; i++) {
              this.store.update(accountUsers[i].id, accountUsers[i]);
            }
          }),
        ),
      this.socketService.getEventStream<string[]>(WebSocketEventsEnum.accountUserDeleted)
        .pipe(tap(id => this.store.remove(id))),
    );
  }
}
